import { addDoc, collection } from "firebase/firestore";
import { db } from "./firebase";

export async function logActivity(uid, name, email, type, data = {}) {
  try {
    await addDoc(collection(db, "activityLog"), {
      uid,
      name: name || "",
      email: email || "",
      type,
      timestamp: new Date().toISOString(),
      ...data,
    });
  } catch (e) {
    // Silently fail — logging should never disrupt the user experience
    console.warn("Activity log failed:", e?.code);
  }
}
